import React, { useEffect, useState } from "react";
import { Box, Button, InputLabel, Stack, TextField, Autocomplete } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { addOrUpdateNews } from "../../Requests/NewsService";
import { News } from "../../Models/News";
import dayjs from "dayjs";
import ImageDropzone from "../StyledComponents/AvatarDropzone/ImageDropzone.tsx";
import { getUsers } from "../../Requests/UserService.ts";
import HtmlEditor from '../HtmlEditorView/HtmlEditor.jsx';


export default function AddNews(props) {

  const [heroImage, setHeroImage] = useState()
  const [title, setTitle] = useState("")
  const [newsDate, setNewsDate] = useState()
  const [source, setSource] = useState("")
  const [description, setDescription] = useState("")
  const [sourceLink, setSourceLink] = useState("")

  const [members, setMembers] = useState([])
  const [selectedMembers, setSelectedMembers] = useState([])

  useEffect(() => {
    fetchMembers()
  }, [])

  const fetchMembers = async () => {
    const result = await getUsers()
    setMembers(result)
  }

  const handlePublish = async () => {
    let object = new News()
    object.title = title
    object.newsDate = dayjs(newsDate).toDate()
    object.source = source
    object.description = description
    object.sourceLink = sourceLink
    object.mentionedMembers = selectedMembers
    await addOrUpdateNews(object, heroImage)
    props.publish()
  }

  return (
    <>
      <Box>
        <ImageDropzone
          title={"Hero Image"}
          callbackFile={(file) => { setHeroImage(file) }}
        />

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Title"}</InputLabel>
          <TextField
            placeholder="Title"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Date"}</InputLabel>
          <DatePicker
            format="DD/MM/YYYY"
            onChange={(newValue) => setNewsDate(newValue)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Source"}</InputLabel>
          <TextField
            placeholder="Source"
            value={source}
            onChange={(event) => setSource(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Members Mentioned"}</InputLabel>
          <Autocomplete
            multiple
            options={members}
            getOptionLabel={(option) => option.name + " " + option.surname}
            filterSelectedOptions
            onChange={(event, value) => setSelectedMembers(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Members"
              />
            )}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Description"}</InputLabel>
          <HtmlEditor initialValue={description} onChange={setDescription} />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Button Link URL"}</InputLabel>
          <TextField
            placeholder="Button Link URL"
            value={sourceLink}
            onChange={(event) => setSourceLink(event.target.value)}
          />
        </Stack>
      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handlePublish()}
        >
          {"Publish"}
        </Button>
      </Box>
    </>
  )
}
